'use strict';

module.exports = {
    CREATED: 'storageProfile.created',
    DELETED: 'storageProfile.deleted'
};